import type { LeagueSummary } from "@tnp/contracts";
import LeagueCover from "../../shared/components/LeagueCover";
import { getLeagueTexts } from "../../shared/leagueTexts";
import { getLeagueFlowTexts } from "../leagueFlowTexts";

type Props = {
  league: LeagueSummary;
  onEdit: (id: string) => void;
  onDelete?: (league: LeagueSummary) => void;
};

export default function LeagueManagementCard({ league, onEdit, onDelete }: Props) {
  const t = getLeagueTexts();
  const f = getLeagueFlowTexts();
  return <article className="admin-tournament-card league-management-card" aria-label={league.name}>
    <div className="admin-tournament-media" aria-hidden="true"><LeagueCover imageUrl={league.imageUrl} /></div>
    <div className="admin-tournament-main">
      <h3><a className="league-table-link" href={`#/organizador/ligas/${league.id}`} onClick={event => {
        if (!event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) { event.preventDefault(); onEdit(league.id); }
      }}>{league.name}</a></h3>
      <p>{t.organizer}: <strong>{league.organizerName}</strong></p>
    </div>
    <div className="admin-tournament-badges"><span className={`league-status league-status--${league.status}`}>{t[league.status]}</span></div>
    <div className="admin-tournament-location"><small>{f.region}</small><strong>{league.venue || t.noVenue}</strong></div>
    <div className="admin-tournament-actions">
      <button className="admin-user-action admin-user-action--primary" type="button" onClick={() => onEdit(league.id)}>{f.edit}</button>
      {onDelete && <button className="admin-user-action admin-user-action--danger" type="button" onClick={() => onDelete(league)}>{f.remove}</button>}
    </div>
  </article>;
}
